"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHorizontalPosition = exports.getVerticalPosition = void 0;

var _constants = require("./constants");

var getVerticalPosition = function getVerticalPosition(vPos) {
  var vertical;

  switch (vPos) {
    case _constants.verticalPosition.TOP:
      vertical = _constants.verticalPosition.BOTTOM;
      break;

    case _constants.verticalPosition.BOTTOM:
      vertical = _constants.verticalPosition.TOP;
      break;

    default:
      vertical = _constants.verticalPosition.MIDDLE;
  }

  return vertical;
};

exports.getVerticalPosition = getVerticalPosition;

var getHorizontalPosition = function getHorizontalPosition(hPos) {
  var horizontal;

  switch (hPos) {
    case _constants.horizontalPosition.LEFT:
      horizontal = _constants.horizontalPosition.RIGHT;
      break;

    case _constants.horizontalPosition.RIGHT:
      horizontal = _constants.horizontalPosition.LEFT;
      break;

    default:
      horizontal = _constants.horizontalPosition.CENTER;
  }

  return horizontal;
};

exports.getHorizontalPosition = getHorizontalPosition;
//# sourceMappingURL=utils.js.map